// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1sDkW","info":"PatientInfo_info__2MQqv"};